import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { StvMonthWiseModel } from 'src/app/models/department-reports.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-stv-month-wise',
  templateUrl: './stv-month-wise.component.html',
  styleUrls: ['./stv-month-wise.component.scss']
})
export class StvMonthWiseComponent implements OnInit {

  monthWise: any[];
  totalApp:number;
  subsidyPaid:number;
  onTime:number;
  pendingByWeek:number;
  pendingMoreThanWeek:number;
  amountPaid:number;
  miArea:number;
  grandTotalApp:number;
  grandSubsidyPaid:number;
  grandOnTime:number;
  grandPendingByWeek:number;
  grandPendingMoreThanWeek:number;
  grandAmountPaid:number;
  grandMiArea:number;
  arrayIndex:number;
  tempMonthWise: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: StvMonthWiseModel[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  displayMaximizable:boolean;
  displayMaximizable_totalApp:boolean;
  displayMaximizable_pendingApp:boolean;
  drilldownDetails:any;
  pendingType:any;
  value:any;
  public subscriptions: any = [];
  public loading: boolean = false;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  constructor(private reportsService:ReportsService
    ,private messageService:MessageService
    ,private router: Router
    ,private dashboard: DashboardService
    ,private activityRecordService: ActivityRecordService
    ,private service: BaseService
    ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    
    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
        
      this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Month_wise_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Month_wise_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }
 
  loadData(selectedYear:any){
    this.loading = true;
    let sub=this.reportsService.getSTV_MonthWise_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'STV Report (Month Wise)', '', new Date(), 'Success');
            data.forEach(e=>{
              if(e.Months.length>0){
                e.Months_sort=e.Months.substr(0,e.Months.length-2)+"20"+e.Months.substr(-2);
              e.Months_sort=new Date (e.Months_sort)
              }
              
             })
            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.monthWise = data;
              this.appVerificationModel = data;
              this.tempMonthWise=data;
              this.arrayIndex=0;
              this.calculateGrandTotal()             
             
            }
            else{
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.monthWise = [];
              this.appVerificationModel = [];
              this.tempMonthWise=[];
              this.arrayIndex=0;
              this.calculateGrandTotal()   
            }
          },
          error: (err) => {
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'STV Report (Month Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }
  exportExcel(modelData, filename) {    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "Months" : d.Months,
          "Total Application": d.TotalApplication,
          "Subsidy Paid": d.SubsidyPaid,
          "On Time": d.PendingEarly,
          "Pending a Week": d.Pending_1Week,
          "Pending More than a Week": d.Pending_Morethan_1Weeks,
          "Amount Paid": d.AmountPaid,
          "MI Area": d.MIArea,
        }
      })     
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'Months', header: 'Months'},
      { field: 'TotalApplication', header: 'Total Application' },
      { field: 'SubsidyPaid', header: 'Subsidy Paid' },
      { field: 'PendingEarly', header: 'On Time' },
      { field: 'Pending_1Week', header: 'Pending a Week' },
      { field: 'Pending_Morethan_1Weeks', header: 'Pending More than a Week' },
      { field: 'AmountPaid', header: 'Amount Paid' },
      { field: 'MIArea', header: 'MI Area' },     
    ];
    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempMonthWise=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    //console.log(this.monthWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
        this.totalApp=0;
        this.subsidyPaid=0;
        this.onTime=0;
        this.pendingByWeek=0;
        this.pendingMoreThanWeek=0;
        this.amountPaid=0;
        this.miArea=0;
        for(let i=this.arrayIndex ;this.tempMonthWise.length>10?i<this.arrayIndex+10:i<this.tempMonthWise.length;i++) {
          // console.log( this.tempMonthWise[i].TotalApplication,"totalAPPPPPPPPP")
          this.totalApp +=this.tempMonthWise[i].TotalApplication;
          this.subsidyPaid +=this.tempMonthWise[i].SubsidyPaid;
          this.onTime += this.tempMonthWise[i].PendingEarly;
          this.pendingByWeek += this.tempMonthWise[i].Pending_1Week;
          this.pendingMoreThanWeek += this.tempMonthWise[i].Pending_Morethan_1Weeks;
          this.amountPaid += this.tempMonthWise[i].AmountPaid;
          this.miArea +=this.tempMonthWise[i].MIArea;

        }      
    }
    calculateGrandTotal(){
      this.grandTotalApp=0;
      this.grandSubsidyPaid=0;
      this.grandOnTime=0;
      this.grandPendingByWeek=0;
      this.grandPendingMoreThanWeek=0;
      this.grandAmountPaid=0;
      this.grandMiArea=0;
      for(let monthData of this.tempMonthWise) {
        this.grandTotalApp += monthData.TotalApplication;
        this.grandSubsidyPaid += monthData.SubsidyPaid;
        this.grandOnTime += monthData.PendingEarly;
        this.grandPendingByWeek += monthData.Pending_1Week;
        this.grandPendingMoreThanWeek += monthData.Pending_Morethan_1Weeks;
        this.grandAmountPaid += monthData.AmountPaid;
        this.grandMiArea += monthData.MIArea;
    }
    }

    showMaximizableDialog_totalApp(value:any) {
      
      
      this.value=value;
      this.drilldownDetails={
        actionType:"STV",
        
        filterType:"Months",
        value:this.value,
        MIType:"",
        Block:""
      }
      
      this.displayMaximizable_totalApp = true;
  
      // console.log(this.value,"value")
      // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }
  showMaximizableDialog_pending(value:any,duration:any) {
      
    if(duration=='early'){
      this.pendingType='On Time'
    }
    if(duration=='1Week'){
      this.pendingType='Pending by Week'
    }
    if(duration=='morethan_1Week'){
      this.pendingType='Pending more than one Week' 
    }
    this.value=value;
    this.drilldownDetails={
      actionType:"STV",
      
      filterType:"Months",
      value:this.value,
      duration:duration,
      MIType:"",
      Block:""
    }
    
    this.displayMaximizable_pendingApp = true;
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }


}
